import { render, staticRenderFns } from "./PaperDetailsPC.vue?vue&type=template&id=bcc42c0c&scoped=true&"
import script from "./PaperDetailsPC.vue?vue&type=script&lang=js&"
export * from "./PaperDetailsPC.vue?vue&type=script&lang=js&"
import style0 from "./PaperDetailsPC.vue?vue&type=style&index=0&id=bcc42c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc42c0c",
  null
  
)

export default component.exports